import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Kicker, Reveal } from "./motion";

export default function SectionHead({ kicker, title, to, linkLabel, light = false, className = "" }) {
  return (
    <Reveal className={`flex flex-wrap items-end justify-between gap-6 ${className}`}>
      <div>
        {kicker && <Kicker light={light}>{kicker}</Kicker>}
        <h2 className={`font-display text-4xl lg:text-5xl mt-4 leading-[1.05] ${light ? "text-white" : "text-ink"}`}>{title}</h2>
      </div>
      {to && (
        <Link
          to={to}
          data-testid={`section-link-${to.replace("/", "") || "home"}`}
          className={`inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap ${light ? "text-gold-light" : "text-forest"}`}
        >
          <span className="gxr-link">{linkLabel}</span> <ArrowRight className="h-4 w-4 rtl:rotate-180" />
        </Link>
      )}
    </Reveal>
  );
}
